export default "__VITE_ASSET__NTalyhol__"